import React from "react";
import { TerminationSectionData } from "../../data/sections/TerminationSectionData";

const Termination = ({ country }) => {
  const fetchTerminationData = country
    ? TerminationSectionData.countries.find(
        (c) =>
          c.country.replace(/\s+/g, "-").toLowerCase() ===
          country.replace(/\s+/g, "-").toLowerCase()
      )
    : null;

  if (!fetchTerminationData) {
    return (
      <div className="termination-section">
        <p className="error-message">
          Country not found or termination data is unavailable.
        </p>
      </div>
    );
  }

  const { details } = fetchTerminationData;

  return (
    <div className="termination-section">
      <h3>Termination</h3>
      {Object.entries(details).map(([key, value], index) => (
        <DynamicRenderer key={index} title={key} data={value} />
      ))}
    </div>
  );
};

// Recursive renderer for dynamic data
const DynamicRenderer = ({ title, data }) => {
  return (
    <div className="termination-dynamic-section">
      <h6>{formatKey(title)}</h6>
      {typeof data === "object" && !Array.isArray(data) ? (
        Object.entries(data).map(([key, value], idx) => (
          <div key={idx} className="nested-section">
            {typeof value === "object" && !Array.isArray(value) ? (
              <DynamicRenderer title={key} data={value} />
            ) : (
              <p>
                <span>{formatKey(key)}:</span> {formatValue(value)}
              </p>
            )}
          </div>
        ))
      ) : (
        <p>{formatValue(data)}</p>
      )}
    </div>
  );
};

// Utility function to format keys
const formatKey = (key) => {
  return key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

// Utility function to format values
const formatValue = (value) => {
  if (Array.isArray(value)) {
    return (
      <ul>
        {value.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
    );
  }
  return value;
};

export default Termination;
